import {combineReducers} from "redux";
import {Action, ActionsTypes, AlertReducer, UIReducer, AuthReducer} from "@leap4/frontend";
import {DateRangeReducer} from "./dateRange.reducer";
const {RESET_ALL_STATES} = ActionsTypes

const reducers = combineReducers({
    auth: AuthReducer,
    ui: UIReducer,
    alert: AlertReducer,
    dates: DateRangeReducer,
});

const rootReducer = (state: any, action: Action) => {

    if (action.type === RESET_ALL_STATES) {
        state = undefined;
    }

    return reducers(state, action);
};

export default rootReducer;
